import { Eyebrow, GoldLine, Reveal } from "@/components/bits";

/* ----------------------------- 8. CHI È CHIARA ---------------------------- */
const chiaraParagraphs = [
  "Donna Virtuosa non nasce perché un giorno ho semplicemente deciso di diventare coach.",
  "Nasce anche dalla mia storia.",
  "Dalla ragazza che sono stata.",
  "Dalla mia adolescenza.",
  "Dalle mie fragilità.",
  "Dalle mie paure.",
  "Dalle relazioni.",
  "Dalle stagioni in cui ho cercato di capire chi fossi davvero.",
  "Dal matrimonio.",
  "Dalle responsabilità.",
  "Dalle volte in cui ho dovuto guardare dentro il mio cuore e riconoscere cose che avrei preferito ignorare.",
];

const chiaraFinal = [
  "Non sono diventata una donna perfetta.",
  "Sono diventata una donna più consapevole di quanto sia importante continuare a lavorare sul proprio cuore.",
  "Ed è anche da qui che nasce Donna Virtuosa.",
  "Non da una posizione di perfezione.",
  "Ma da un cammino reale.",
  "Da una donna che continua ancora oggi a crescere, imparare e scegliere ogni giorno di mettere Dio al centro.",
];

export const Chiara = () => (
  <section id="chiara" data-testid="chiara-section" className="scroll-mt-24 bg-[#F4EFE6]">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 py-24 md:px-10 md:py-36 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <Reveal className="lg:sticky lg:top-32">
          <div className="relative">
            <div className="absolute -right-4 -top-4 h-full w-full border border-[#D4AF37]/50" aria-hidden="true" />
            <div className="relative overflow-hidden">
              <img
                src="/images/chiara-ritratto.jpg"
                alt="Chiara Perrone il giorno del suo matrimonio"
                data-testid="chiara-image"
                className="h-full w-full scale-100 object-cover transition-transform duration-[2000ms] ease-out hover:scale-105"
                loading="lazy"
              />
            </div>
          </div>
          <div className="mt-12 overflow-hidden">
            <img
              src="/images/chiara-elio-marina.jpg"
              alt="Chiara con suo marito Elio"
              data-testid="chiara-elio-image"
              className="h-auto w-full scale-100 transition-transform duration-[2000ms] ease-out hover:scale-105"
              loading="lazy"
            />
            <p className="mt-3 text-right text-xs uppercase tracking-[0.22em] text-[#3A3532]/50">
              Con mio marito Elio
            </p>
          </div>
        </Reveal>
      </div>
      <div className="lg:col-span-7">
        <Reveal>
          <Eyebrow>La donna dietro Donna Virtuosa</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 font-serif text-3xl leading-tight tracking-tight text-[#1A1818] md:text-5xl">
            Ciao, sono Chiara.
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-8 text-base leading-relaxed text-[#3A3532] md:text-lg">
            Sono{" "}
            <strong className="font-semibold text-[#1A1818]">
              Chiara Perrone, Life Coach Cristiana, moglie, imprenditrice e co-founder di Fede &amp;
              Fitness Italia insieme a mio marito Elio.
            </strong>
          </p>
        </Reveal>
        <div className="mt-6 space-y-2 text-base leading-relaxed text-[#3A3532] md:text-lg">
          {chiaraParagraphs.map((p, i) => (
            <Reveal key={p} delay={0.03 * i}>
              <p>{p}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <div className="mt-10 border-l-2 border-[#D4AF37] pl-6">
            <p className="text-base leading-relaxed text-[#3A3532] md:text-lg">
              E nasce anche da uno dei momenti più dolorosi della mia vita.
            </p>
            <p className="mt-2 font-serif text-xl italic leading-snug text-[#1A1818] md:text-2xl">
              La perdita di nostra figlia durante la gravidanza.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="mt-8 space-y-4 text-base leading-relaxed text-[#3A3532] md:text-lg">
            <p>Ci sono dolori che non puoi semplicemente cancellare.</p>
            <p>Ma ci sono dolori davanti ai quali puoi decidere dove portare il tuo cuore.</p>
            <p>Per me quella stagione ha reso ancora più profonda la mia ricerca del Signore.</p>
            <p>
              Mi ha portata a interrogarmi sulla fede, sull&rsquo;identità, sul controllo, sulla
              paura, sulla sofferenza e su cosa significhi realmente affidarsi a Dio quando la vita
              non va come avevi immaginato.
            </p>
          </div>
        </Reveal>
        <div className="mt-10 space-y-2 text-base leading-relaxed text-[#3A3532] md:text-lg">
          {chiaraFinal.map((p, i) => (
            <Reveal key={p} delay={0.03 * i}>
              <p className={i === chiaraFinal.length - 1 ? "font-medium text-[#1A1818]" : ""}>{p}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);

/* -------------------------- 9. IL MIO RUOLO -------------------------- */
const ruoloNot = [
  "Il mio compito come Life Coach non è decidere la tua vita.",
  "Non è dirti cosa devi pensare.",
  "Non è sostituirmi a Dio.",
  "Non è sostituirmi a una psicologa, una terapeuta o una figura pastorale.",
];

const ruoloYes = [
  "Il mio lavoro è aiutarti a fare chiarezza.",
  "A riconoscere schemi.",
  "A farti domande che forse da sola continui a evitare.",
  "A comprendere meglio ciò che senti.",
  "A prendere responsabilità.",
  "A costruire nuove abitudini.",
  "A trasformare ciò che comprendi in azioni concrete.",
  "E soprattutto a iniziare a vivere in maniera più intenzionale.",
];

export const Ruolo = () => (
  <section data-testid="ruolo-section">
    <div className="mx-auto max-w-3xl px-6 py-24 md:px-10 md:py-36">
      <Reveal>
        <h2 className="font-serif text-3xl leading-tight tracking-tight text-[#1A1818] md:text-5xl">
          Non posso camminare al posto tuo.
          <span className="mt-3 block text-2xl text-[#3A3532] md:text-3xl">
            Ma posso aiutarti a vedere dove stai andando.
          </span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <GoldLine className="mt-10" />
      </Reveal>
      <div className="mt-10 space-y-2 text-base text-[#3A3532] md:text-lg">
        {ruoloNot.map((p, i) => (
          <Reveal key={p} delay={0.04 * i}>
            <p>{p}</p>
          </Reveal>
        ))}
      </div>
      <div className="mt-10">
        {ruoloYes.map((p, i) => (
          <Reveal key={p} delay={0.04 * i}>
            <p className="flex items-baseline gap-3 border-b border-[#2A2421]/10 py-3 text-base text-[#3A3532] md:text-lg">
              <span className="h-px w-4 shrink-0 translate-y-[-5px] bg-[#D4AF37]" aria-hidden="true" />
              {p}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

/* ---------------------------- 10. PRIMA E DOPO ---------------------------- */
const prima = [
  "Reagisco.", "Accumulo.", "Cerco approvazione.", "Mi confronto.", "Controllo.",
  "Mi chiudo.", "Esplodo.", "Mi sento in colpa.", "Prometto di cambiare.", "Ricominciamo da capo.",
];
const dopo = [
  "Riconosco.", "Mi fermo.", "Comprendo.", "Porto davanti a Dio.", "Scelgo.",
  "Comunico.", "Metto confini.", "Agisco.", "Valuto il frutto delle mie decisioni.", "Continuo a crescere.",
];

export const PrimaDopo = () => (
  <section data-testid="prima-dopo-section" className="bg-[#F4EFE6]">
    <div className="mx-auto max-w-6xl px-6 py-24 md:px-10 md:py-36">
      <Reveal>
        <h2 className="max-w-3xl font-serif text-3xl leading-tight tracking-tight text-[#1A1818] md:text-5xl">
          Cosa succede quando inizi a cambiare da dentro?
        </h2>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-12">
        <Reveal>
          <div data-testid="prima-column" className="h-full border border-[#2A2421]/10 bg-[#FDFBF7] p-8 md:p-12">
            <h3 className="text-xs font-semibold uppercase tracking-[0.28em] text-[#3A3532]/60">Prima</h3>
            <ul className="mt-6">
              {prima.map((item) => (
                <li key={item} className="border-b border-[#2A2421]/10 py-3 font-serif text-xl text-[#3A3532]/70 md:text-2xl">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div data-testid="dopo-column" className="h-full border border-[#D4AF37]/50 bg-[#1A1818] p-8 md:p-12">
            <h3 className="text-xs font-semibold uppercase tracking-[0.28em] text-[#D4AF37]">Dopo</h3>
            <ul className="mt-6">
              {dopo.map((item) => (
                <li key={item} className="border-b border-[#FDFBF7]/10 py-3 font-serif text-xl text-[#FDFBF7] md:text-2xl">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
      <Reveal delay={0.1}>
        <div className="mx-auto mt-14 max-w-3xl text-center">
          <p className="text-base text-[#3A3532] md:text-lg">Non significa non provare più emozioni.</p>
          <p className="mt-2 font-serif text-2xl italic leading-snug text-[#1A1818] md:text-3xl">
            Significa imparare a non esserne governata.
          </p>
        </div>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mx-auto mt-16 max-w-xl overflow-hidden">
          <img
            src="/images/chiara-elio-mare.jpg"
            alt="Chiara ed Elio in un momento di quotidianità al mare"
            data-testid="prima-dopo-image"
            className="h-auto w-full scale-100 transition-transform duration-[2000ms] ease-out hover:scale-105"
            loading="lazy"
          />
        </div>
      </Reveal>
    </div>
  </section>
);

/* --------------------- 11. NON SIGNIFICA DONNA PERFETTA --------------------- */
const proverbiTraits = [
  "È una donna che teme Dio.", "Lavora.", "Amministra.", "Decide.", "Provvede.", "Costruisce.",
  "Parla con sapienza.", "Si prende cura.", "È diligente.", "Ha responsabilità.", "Ha forza.", "Ha dignità.",
];

export const Proverbi = () => (
  <section data-testid="proverbi-section">
    <div className="mx-auto max-w-7xl px-6 py-24 md:px-10 md:py-36">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <h2 className="font-serif text-3xl leading-tight tracking-tight text-[#1A1818] md:text-5xl">
              “Donna Virtuosa” non significa “donna perfetta”.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 max-w-2xl text-base leading-relaxed text-[#3A3532] md:text-lg">
              Per troppo tempo alcune donne hanno interpretato la femminilità cristiana come
              silenzio, passività, sacrificio senza confini o annullamento personale.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-[#3A3532] md:text-lg">
              Ma la donna che troviamo in Proverbi 31 non è una donna senza forza.
            </p>
          </Reveal>
          <div className="mt-8 grid max-w-2xl grid-cols-1 gap-x-10 sm:grid-cols-2">
            {proverbiTraits.map((t, i) => (
              <Reveal key={t} delay={0.03 * i}>
                <p className="flex items-baseline gap-3 border-b border-[#2A2421]/10 py-3 text-base text-[#3A3532] md:text-lg">
                  <span className="h-px w-4 shrink-0 translate-y-[-5px] bg-[#D4AF37]" aria-hidden="true" />
                  {t}
                </p>
              </Reveal>
            ))}
          </div>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <div className="overflow-hidden">
              <img
                src="/images/chiara-elio-matrimonio.jpg"
                alt="Chiara ed Elio il giorno del matrimonio"
                data-testid="proverbi-image"
                className="aspect-[4/3] w-full scale-100 object-cover transition-transform duration-[2000ms] ease-out hover:scale-105"
                loading="lazy"
              />
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <blockquote className="mt-8 border-l-2 border-[#D4AF37] pl-6" data-testid="proverbi-verse">
              <p className="font-serif text-xl italic leading-snug text-[#1A1818] md:text-2xl">
                “Forza e dignità sono il suo manto, e lei guarda fiduciosa all&rsquo;avvenire.”
              </p>
              <cite className="mt-3 block text-xs font-semibold uppercase not-italic tracking-[0.22em] text-[#A98A2C]">
                Proverbi 31:25
              </cite>
            </blockquote>
          </Reveal>
        </div>
      </div>
      <div className="mt-20 text-center md:mt-28">
        <Reveal>
          <p className="font-serif text-2xl uppercase leading-snug tracking-[0.06em] text-[#1A1818] md:text-4xl">
            Una donna con cuore.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-3 font-serif text-2xl uppercase leading-snug tracking-[0.06em] text-[#1A1818] md:text-4xl">
            Una donna con governo.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <p className="mt-3 font-serif text-2xl uppercase leading-snug tracking-[0.06em] text-[#A98A2C] md:text-4xl">
            Una donna che porta frutto.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
